module.exports = __webpack_public_path__ + "img/control_de_calidad2_4-3_3072.879523f9.webp";